import { primitiveColors } from '../colors';
import { SemanticColors } from '../semantic-colors';

export const semanticColors = {
    background: {
        default: primitiveColors.gray[200],
        alternative: primitiveColors.gray[300],
        subtle: primitiveColors.gray.fff,
        // Figma alias: {Background.subtle}
        inverted: primitiveColors.gray.fff,
        disabled: primitiveColors.gray[300],
        accent: primitiveColors.skydome[400],
        accentLight: primitiveColors.skydome[50],
        // Keep the old colors for charging and paused for now, they have changed in figma without notice (we need to discuss those first).
        charging: primitiveColors.defaBlue[500],
        paused: primitiveColors.defaDarkBlue[500],
        success: primitiveColors.green[400],
        attention: primitiveColors.urbanOrange['200'],
        error: primitiveColors.red[500],
        banner: primitiveColors.skydome[500],
        unavailable: primitiveColors.gray[600],
    },

    foreground: {
        default: primitiveColors.gray['000'],
        alternative: primitiveColors.gray[800],
        subtle: primitiveColors.gray[700],
        light: primitiveColors.gray.fff,
        disabled: primitiveColors.gray[500],
        accent: primitiveColors.skydome[400],
        accentDark: primitiveColors.skydome[500],
        secondaryControls: primitiveColors.urbanOrange['500'],
        // Keep the old color for charging for now, it has changed in figma without notice (we need to discuss those first).
        charging: primitiveColors.defaBlue[500],
        success: primitiveColors.green[400],
        attention: primitiveColors.urbanOrange['550'],
        error: primitiveColors.red[500],
        iosDetails: primitiveColors.gray[300],
        solar: primitiveColors.solar,
    },

    effects: {
        hover: 'rgba(0, 0, 0, 0.04)',
        pressed: 'rgba(0, 0, 0, 0.15)',
    },

    border: {
        default: primitiveColors.gray[500],
        alternative: primitiveColors.gray[400],
        subtle: primitiveColors.gray[300],
        light: primitiveColors.gray.fff,
        accent: primitiveColors.skydome[400],
        success: primitiveColors.green[450],
        attention: primitiveColors.urbanOrange['500'],
        error: primitiveColors.red[500],
    },

    status: {
        default: {
            background: primitiveColors.gray[200],
            border: primitiveColors.gray[400],
            text: primitiveColors.gray['000'],
        },
        info: {
            background: primitiveColors.electricBlue[200],
            border: primitiveColors.electricBlue[500],
            text: primitiveColors.electricBlue[900],
        },
        success: {
            background: primitiveColors.green[100],
            border: primitiveColors.green[300],
            text: primitiveColors.green[800],
        },
        danger: {
            background: primitiveColors.red[100],
            border: primitiveColors.red[200],
            text: primitiveColors.red[700],
        },
        attention: {
            background: primitiveColors.urbanOrange[200],
            border: primitiveColors.urbanOrange[500],
            // Differs from Figma (which uses black). Aligned with the other
            // status variants, which use a deep shade of their own hue for
            // text. Update Figma to match.
            text: primitiveColors.urbanOrange[700],
        },
    },
} satisfies SemanticColors;
